/** Implements https://aka.ms/CorrelationVector */
export class CorrelationVector {
    constructor(id) {
        this.childCount = 0;
        this.id = id || generateBase64PseudoUuid();
    }
    /**
     * Extracts a prefix from the given ID and instantiates CorrelationVector
     * that will optionally start with a given childCount
     * @param id This CorrelationVector node
     * @param childCount An optional starting value when it is known
     * @see {@link newChild}
     * @example <caption>Root child</caption>
     * // returns new CorrelationVector('ABCD.1')
     * CorrelationVector.fromString('ABCD.1.0')
     * @example <caption>Direct ID</caption>
     * // returns new CorrelationVector('ABCD.5.10')
     * CorrelationVector.fromString('ABCD.5.10')
     */
    static fromString(id, childCount) {
        if (!id) {
            throw new Error('Received invalid correlation vector string');
        }
        let cv;
        if (!id.endsWith('.0')) {
            cv = new CorrelationVector(id);
        }
        else {
            cv = new CorrelationVector(id.substring(0, id.length - 2));
        }
        if (childCount) {
            cv.childCount = childCount;
        }
        return cv;
    }
    /**
     * Generates a CorrelationVector object for the next child
     * @returns Each time a new CorrelationVector with an increasing index
     * @see {@link fromString}
     * @example
     * const cv = CorrelationVector.fromString('ABCD.1.0', 4)
     * // returns new CorrelationVector('ABCD.1.5')
     * cv.newChild()
     * // returns new CorrelationVector('ABCD.1.6')
     * cv.newChild()
     */
    newChild() {
        ++this.childCount;
        return new CorrelationVector(this.id + '.' + this.childCount.toString());
    }
    toString() {
        if (this.id.length > 127) {
            return this.id.substring(0, 127) + '!';
        }
        return this.id;
    }
}
const characters = [
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I',
    'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
    'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a',
    'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j',
    'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's',
    't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1',
    '2', '3', '4', '5', '6', '7', '8', '9', '+',
    '/'
];
const hashLength = 22;
const result = new Array(hashLength);
function generateBase64PseudoUuid() {
    for (let i = 0; i < hashLength; i++) {
        result[i] = characters[Math.floor(Math.random() * characters.length)];
    }
    return result.join('');
}
//# sourceMappingURL=correlation-vector.js.map